// src/components/InstagramModal.tsx
import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import "bootstrap/dist/css/bootstrap.min.css";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConnected: () => void;
}

const InstagramModal: React.FC<ModalProps> = ({ isOpen, onClose, onConnected }) => {
  const [accessToken, setAccessToken] = useState<string>("");
  const [authentication, setAuthentication] = useState<string>(
    "Admin API Access Token"
  );

  const instaConnected = () => {
    if (!accessToken.trim()) {
      message.error("Please enter an access token before connecting.");
      return;
    }
    message.success("Instagram connection created successfully!");
    onConnected();
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={500}
      className="instagram-modal"
    >
      <div className="innerbody text-center">
        <img
          id="Instagram-logo"
          src="/images/instagram.png"
          alt="Instagram Icon"
          className="mb-3"
          style={{ width: "60px", height: "60px" }}
        />

        {/* Authentication */}
        <div className="form-input text-start">
          <label htmlFor="authentication" className="form-label fw-bold">
            Authentication
          </label>
          <select
            id="authentication"
            className="form-select"
            value={authentication}
            onChange={e => setAuthentication(e.target.value)}
          >
            <option value="Admin API Access Token">Admin API Access Token</option>
            <option value="OAuth 2.0">OAuth 2.0</option>
          </select>
        </div>

        {/* Access Token */}
        <div className="form-input mt-3 text-start">
          <label htmlFor="accessToken" className="form-label fw-bold">
            Access Token
          </label>
          <input
            type="text"
            id="accessToken"
            className="form-control"
            placeholder="Enter your access token"
            value={accessToken}
            onChange={e => setAccessToken(e.target.value)}
          />
        </div>

        {/* Buttons */}
        <div className="button-group mt-4 d-flex justify-content-center flex-wrap gap-3">
          <Button
            type="primary"
            className="button button--connection"
            onClick={instaConnected}
          >
            Create Connection
          </Button>

          <Button className="button button--danger" onClick={onClose}>
            Cancel
          </Button>

          <Button
            className="button button--primary"
            type="default"
            onClick={() => message.info("Testing Instagram connection...")}
          >
            Test Connection
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InstagramModal;
